





















































































































































import { Component, Vue } from "vue-property-decorator";
import { storeCpCompliance } from "@/store/modules/CpComplianceStore";
import CpComplianceSvc from "@/services/CpComplianceService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import moment from "moment";
import CpComplianceForm from "./CpComplianceForm.vue";
import CpComplianceDetail from "./CpComplianceDetail.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";

@Component({
  components: { CpComplianceForm, CpComplianceDetail, VCDateTimePicker }
})
export default class CpComplianceList extends Vue {
  storeModule = storeCpCompliance;
  showDetail = false;
  editData: any = null;
  isReadonly = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterCp: any = null;
  filterKepatuhan: any = null;
  filterStatus: any = null;
  filterSearch = "";

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted", value: "submitted" },
    { text: "Ditandatangani PPA", value: "signed_ppa" },
    { text: "Ditandatangani Ka. SMF", value: "signed_ka_smf" },
    { text: "Disetujui Komite", value: "signed_komite" },
  ];

  kepatuhanOptions = [
    { text: "PATUH", value: "patuh" },
    { text: "TIDAK PATUH", value: "tidak_patuh" },
    { text: "EKSKLUSI", value: "eksklusi" },
  ];

  headers = [
    { text: "No. Formulir", value: "nomor_formulir", width: "155px" },
    { text: "Tgl. Evaluasi", value: "tgl_evaluasi", width: "110px" },
    { text: "CP", value: "cp_definition", width: "140px" },
    { text: "Pasien", value: "pasien" },
    { text: "DPJP", value: "dpjp_nama", width: "140px" },
    { text: "LOS", value: "los_aktual", width: "70px" },
    { text: "Kepatuhan", value: "status_kepatuhan", width: "110px" },
    { text: "Kesesuaian", value: "persentase_kesesuaian", width: "95px" },
    { text: "Status", value: "status", width: "130px" },
    { text: "Aksi", value: "actions", sortable: false, width: "110px" },
  ];

  get cpOptions() {
    return this.storeModule.definitions.map((d: any) => ({
      text: `${d.kode} - ${d.nama_pathway}`,
      value: d.id,
    }));
  }

  parseLocalDate = parseLocalDate;

  mounted() {
    this.storeModule.loadDefinitions();
    this.loadData();
  }

  setFilterTgl(field: "filterTglDari" | "filterTglSampai", val: Date | null) {
    const next = val ? localISODate(val) : "";
    if (next === this[field]) return;
    this[field] = next;
    this.loadData();
  }

  async loadData() {
    const params: any = {};
    if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
    if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
    if (this.filterCp) params.cp_definition_id = this.filterCp;
    if (this.filterKepatuhan) params.status_kepatuhan = this.filterKepatuhan;
    if (this.filterStatus) params.status = this.filterStatus;
    if (this.filterSearch) params.search = this.filterSearch;
    await this.storeModule.loadSessions(params);
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  tambahBaru() {
    this.editData = null;
    this.isReadonly = false;
    this.showDetail = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.isReadonly = item.is_locked;
    this.showDetail = true;
  }

  bisaHapus(item: any): boolean {
    if (!item.is_locked) return true;
    const slots = [
      { ditandatangani: item.signed_ppa_at, penandaTanganId: item.ppa_user_id },
      { ditandatangani: item.signed_ka_smf_at, penandaTanganId: item.ka_smf_user_id },
      { ditandatangani: item.signed_komite_at, penandaTanganId: item.komite_user_id }
    ];
    if (!slots.some(slot => !!slot.ditandatangani)) return false;
    return !alasanTtdMengunciHapus(item.creator_user_id, slots, userModule.user?.id);
  }

  async hapus(item: any) {
    if (!this.bisaHapus(item)) return;
    if (!confirm("Hapus evaluasi kepatuhan CP ini?")) return;
    try {
      const resp = await CpComplianceSvc.destroy(item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menghapus data");
        this.loadData();
      }
    } catch {
      // handled by ErrorAlert
    }
  }

  printPdf(id: number) {
    CpComplianceSvc.printPdf(id);
  }

  onBack() {
    this.showDetail = false;
    this.editData = null;
    this.loadData();
  }

  onSaved() {
    this.loadData();
  }
}
